import { Chip } from "@mui/material";
import { useRecordContext } from "react-admin";

// hasOutstandingDebts is deliberately nullable: null means the billing state could not be
// established, which must not read as "nothing owed".
const OutstandingDebtField = () => {
  const record = useRecordContext();
  const hasOutstandingDebts = record?.hasOutstandingDebts;

  if (hasOutstandingDebts === true) {
    return (
      <Chip
        label="Има задължения"
        color="error"
        size="small"
      />
    );
  }

  if (hasOutstandingDebts === false) {
    return (
      <Chip
        label="Без задължения"
        color="success"
        size="small"
      />
    );
  }

  return (
    <Chip
      label="Няма информация"
      variant="outlined"
      size="small"
    />
  );
};

export default OutstandingDebtField;
